export interface SalesDespatchItemForStockReturn {
  id: string;
  stockNo: string;
  orderNo: string;
  productKey: string;
  productDescription: string;
  invoicePrice: number;
  freeOfChargeQty: number;
  grossQuantity: number;
  nettQuantity: number;
  invoiceValue: number;
  returnedQuantity: number;
  despatchNoteNo: number;
  despatchDate: Date;
  salesOrderNo: number;
  sequence: number;
}
